import React from "react";
import { useDropzone } from "react-dropzone";

const getClassName = (className, isActive) => {
  if (!isActive) return `${className} ${className}-custom`;
  return `${className} ${className}-custom ${className}-active`;
};

const Dropzone = ({ onDrop, accept }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept
  });

  return (
    <div className={getClassName("dropzone", isDragActive)} {...getRootProps()}>
      <input {...getInputProps()}/>
      <p className="instructions">Drag and Drop Files Here</p>
    </div>
  );
};

export default Dropzone;